import React from 'react';
import Style from '../../../style.module.css';


type TypeOtpInput = {
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
};

const OtpInput = React.forwardRef<HTMLInputElement, TypeOtpInput>(({ onChange }, ref) => {
    return (
        <input
            type="text"
            className={Style.otpInput}
            maxLength={1}
            onChange={onChange}
            ref={ref}
        />
    );
});

export default OtpInput;